// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const WikiMapProvider = registerClientReference(
    function() { throw new Error("Attempted to call WikiMapProvider() from the server but WikiMapProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/nextapp/src/contexts/WikiMapContext.tsx",
    "WikiMapProvider",
);
export const useWikiMapContext = registerClientReference(
    function() { throw new Error("Attempted to call useWikiMapContext() from the server but useWikiMapContext is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/nextapp/src/contexts/WikiMapContext.tsx",
    "useWikiMapContext",
);
